import { darkTeams, noShadowTeams } from "../hooks/vars"
import teamsBasic from "../data/teamsBasic2025.json";
import { motion, AnimatePresence } from "framer-motion";
import { GetTeamStandingsConf, UseStandingsConf } from "../hooks/getStandings";

export function TeamRankCard(props) {
  //t=team key rank=rank record=record
  const teamData = teamsBasic.find((data) => data.Key === props.t);
  const darkTeam = darkTeams.includes(teamData.Key);

  return (
    <motion.div
      layout
      layoutId={"team-" + props.t}
      className="standingsRow"
      key={props.k}
      style={{
        //background: "#" + teamData.PrimaryColor,
        background:
          "linear-gradient(15deg,#000 -100%, #" +
          teamData.PrimaryColor +
          " 40%)",
        color:
          "#" + (!darkTeam ? teamData.SecondaryColor : teamData.TertiaryColor),
        textShadow: noShadowTeams.includes(teamData.Key)
          ? ".5px .5px 0px #ffffff36"
          : "1px 1px 0 #00000085",
      }}
      //initial={{ opacity: 0, y: 10 }}
      //animate={{ duration: 1, opacity: 1, y: 0 }}
      //exit={{ duration: 1, opacity: 0, y: -10 }}
      transition={{ duration: 1, type: 'spring', bounce: .5, mass: 5, damping: 25 }}
    >
      <div
        className="teamCardLogo"
        style={{
          backgroundImage: "url(" + teamData.WikipediaLogoURL + ")",
        }}
      ></div>
      <div className="confRank">{props.rank}</div>
      <div className="teamCardName">
        {teamData.Name} {darkTeam}
      </div>
      <div className="record">{props.record}</div>
    </motion.div>
  );
}

export function StandingsModule() {
  return (
    <>
      <div className="defaultModal standingsModule">
        <AnimatePresence>
          <div className="cont">
            <h3
              style={{
                gridColumnStart: 1,
                gridColumnEnd: 3,
              }}
            >
              LEAGUE STANDINGS
            </h3>
            <motion.div className="standingsColumn" layout>
              <h5>AFC</h5>

              <GetTeamStandingsConf c="AFC" />
            </motion.div>
            <motion.div className="standingsColumn" layout>
              <h5>NFC</h5>

              <GetTeamStandingsConf c="NFC" />
            </motion.div>
            <div className="refetchButtonContainer"></div>
          </div>
        </AnimatePresence>{" "}
        <RefetchButton />
      </div>
    </>
  );
}


export function RefetchButton() {
  const { refetch } = UseStandingsConf();
  return (
    <>
      <button className="toggleButton refetchButton" onClick={refetch}>
        Refetch Standings
      </button>
    </>
  );
}
